import React from 'react'
import propTypes, { object, shape } from 'prop-types'
import OnDemandComponent from './OnDemand'
import LiveComponent from './Live'
import styles from './VideoPlayer.module.scss'

export const VideoPlayer = ({
  eventName,
  name,
  youtubeId,
  description,
  eventFullUrlPath,
  descriptionDetails,
  image = {},
  locations,
  live,
  agendaSnapshot,
  fullAgenda
}) => {
  if (!live)
    return (
      <OnDemandComponent
        eventName={eventName}
        name={name}
        youtubeId={youtubeId}
        description={description}
        eventFullUrlPath={eventFullUrlPath}
        descriptionDetails={descriptionDetails}
        image={image}
      />
    )
  return (
    <div className={styles.LiveVideoPlayerWrapper}>
      <LiveComponent
        eventName={eventName}
        eventFullUrlPath={eventFullUrlPath}
        descriptionDetails={descriptionDetails}
        image={image}
        locations={locations}
        agendaSnapshot={agendaSnapshot}
        fullAgenda={fullAgenda}
      />
    </div>
  )
}

VideoPlayer.propTypes = {
  eventName: propTypes.string,
  eventFullUrlPath: propTypes.string,
  name: propTypes.string,
  description: propTypes.string,
  youtubeId: propTypes.string,
  descriptionDetails: propTypes.string,
  live: propTypes.bool,
  locations: propTypes.array,
  agendaSnapshot: propTypes.object,
  fullAgenda: propTypes.array,
  image: shape({
    mobile: object,
    desktop: object
  })
}
